import institutionAPI from 'services/institutionAPI'
import { ProfessionalContractTypeFilters } from 'InstitutionalManagement/types'

type Params = {
  filters: ProfessionalContractTypeFilters
}

export default async function readProfessionalContractTypesOnCustomForm({ filters }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    url: '/admin/contract-type/contract-types',
    data: filters,
  })

  return response
}
